<div class="copy-cell">
    @if(displayContent() !== naLabel() && displayContent() !== '') {
    <span class="copy-cell-text" [class.truncated]="isTruncated()" (click)="copyToClipboard(textTooltip)"
        [matTooltip]="tooltipContent()" #textTooltip="matTooltip">
        {{ displayContent() }}
    </span>

    <button mat-icon-button type="button" class="copy-cell-btn" (click)="copyToClipboard(buttonTooltip)"
        [matTooltip]="iconTooltipContent()" matTooltipClass="copy-tooltip" #buttonTooltip="matTooltip">
        <mat-icon>content_copy</mat-icon>
    </button>
    }
    @else {
    <span class="copy-cell-text">
        {{ displayContent() }}
    </span>
    }
</div>